import { myAxios } from "./axios";

export function getLeaves(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/holidays", config);
}

export function getLeave(id) {
  return myAxios.get("/holidays/" + id);
}

export function addLeave(data) {
  return myAxios.post("/holidays/create", data);
}

export function editLeave(id, data) {
  return myAxios.put("/holidays/" + id + "/update", data);
}

export function deleteLeave(id) {
  return myAxios.delete("/holidays/" + id + "/delete");
}

export function editLeaveStatus(id, data) {
  return myAxios.put("/holidays/" + id + "/change-status", data);
}
